import React, { FC } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import { Typography, useTranslate, BrandIconShared, FNOLPageWrapper } from '@dg-shared'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import { Events } from '../../../FSM/shared/constants'
import { Button, ButtonGroup } from '@material-ui/core'
import { TRANSLATIONS as T } from '../../../constants'
import { IconType } from '../../../types/interface/icon.interface'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btnGroup: {
      display: 'flex',
      height: 'inherit',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        width: '400px',
        margin: 'auto',
        marginTop: theme.spacing(5),
        paddingTop: theme.spacing(3),
      },
    },
    btn: {
      flex: 1,
      borderRadius: 0,
      height: '132px',
      borderColor: theme.palette.info.main,
      '& [class*="label"]': {
        flexDirection: 'column',
      },
      '&:hover': {
        background: theme.palette.primary.main,
        '& [class*="label"]': {
          '& svg, & p': {
            color: theme.palette.primary.contrastText,
          },
        },
      },
    },
    btnText: {
      textTransform: 'initial',
      lineHeight: 'normal',
      wordBreak: 'break-word',
    },
    icon: {
      fontSize: theme.spacing(4),
      marginBottom: theme.spacing(0.5),
    },
  })
)

const FNOLMyPage: FC<CommonPageProps> = ({ service }) => {
  const classes = useStyles()
  const { t } = useTranslate(T.MY_PAGE)

  const { send } = service

  const btnGroup = (
    <ButtonGroup className={classes.btnGroup}>
      <Button
        data-testid='documents'
        onClick={() => send(Events.FNOL_DOCUMENTS_LIST)}
        className={classes.btn}
        fullWidth
      >
        <BrandIconShared type={IconType.BEACH_ACCESS} customClass={classes.icon} />
        <Typography testId='documents-btn-title' className={classes.btnText}>
          {t('button.documents')}
        </Typography>
      </Button>
      <Button
        data-testid='claims'
        onClick={() => send(Events.FNOL_CLAIMS)}
        className={classes.btn}
        fullWidth
      >
        <BrandIconShared type={IconType.FILE_COPY} customClass={classes.icon} />
        <Typography testId='claims-btn-title' className={classes.btnText}>
          {t('button.reportDamage')}
        </Typography>
      </Button>
    </ButtonGroup>
  )

  const content = (
    <>
      <Typography type='h1' testId='title'>
        {t('title')}
      </Typography>
      {btnGroup}
    </>
  )

  return <FNOLPageWrapper breadcrumbsBtnText={t('back')}>{content}</FNOLPageWrapper>
}

export default FNOLMyPage
